import _AutocompleteAddress from "./AutocompleteAddress";
import { withErrorMessage } from "../withErrorMessage";

export { Autocomplete } from "./Autocomplete";

export const AutocompleteAddress = withErrorMessage(_AutocompleteAddress);
